<template>
  <div class="card-img-top" v-if="institution">
    <figcaption v-if="isProvided">
      Provided by
    </figcaption>
    <router-link
      :to="{ name: 'institution', params: { id: institution.institution } }"
      :event="clickable ? 'click' : ''"
      :class="{ not_clickable: !clickable }"
    >
      <img
        style="height: 50px;width:auto;"
        :src="
          `${IREALCONFIG.static_ressources}/institutes/${institution.institution}.png`
        "
        alt="ireal institution partner"
      />
    </router-link>
  </div>
</template>

<script>
// The Root component for viewing an IREAL experiment

// @ is an alias to /src
import httpMixin from "ireal-vue/mixins/http-mixin.js";

export default {
  name: "institution-component",
  props: ["institution", "isProvided", "isEmbedded"],
  mixins: [httpMixin],
  data() {
    return {};
  },
  mounted() {
    this.load();
  },
  computed: {
    clickable() {
      return this.isEmbedded == true || this.isEmbedded == undefined;
    }
  },
  methods: {
    async load() {}
  }
};
</script>
<style scoped>
.not_clickable {
  cursor: default;
}
figcaption {
  width: 80px;
  font-style: italic;
  font-size: 10px;
  margin-right: 5%;
  font-weight: 100;
}
.wrapper figcaption {
  margin-left: 2%;
}
img {
  width: 70px;
  z-index: 1;
  margin-right: 5%;
  margin-bottom: 2%;
}
.wrapper img {
  margin-left: 2%;
}
</style>
